import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPhoneArrowRight } from '@awesome.me/kit-b257fa7ca4/icons/classic/solid';

library.add(faPhoneArrowRight);

Vue.component('font-awesome-icon', FontAwesomeIcon);
